import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getTaskDifficultyDisplayName, getTaskDifficultyIcon, TaskDifficulty } from '../../../services/task';
import Icon from '../../../ui/Icon';
import Slider, { SliderSize } from '../../../ui/Slider';

interface Props {
    difficulty?: TaskDifficulty;
    onChange: (value: TaskDifficulty) => void;
    className?: any;
}

// const difficulties = [
//     { value: 0, label: <div className='difficulty-slider-mark-label lvl-0'><Icon size={16} icon={getTaskDifficultyIcon(0)}></Icon></div>, color: '#1976d2' },
//     { value: 1, label: <div className='difficulty-slider-mark-label lvl-1'><Icon size={16} icon={getTaskDifficultyIcon(1)}></Icon></div>, color: '#00796b' },
//     { value: 2, label: <div className='difficulty-slider-mark-label lvl-2'><Icon size={16} icon={getTaskDifficultyIcon(2)}></Icon></div>, color: '#dbb02d' },
//     { value: 3, label: <div className='difficulty-slider-mark-label lvl-3'><Icon size={16} icon={getTaskDifficultyIcon(3)}></Icon></div>, color: '#e64a19' },
//     { value: 4, label: <div className='difficulty-slider-mark-label lvl-4'><Icon size={16} icon={getTaskDifficultyIcon(4)}></Icon></div>, color: '#d32f2f' }
// ];

const difficulties = [
    { value: 0, label: <Icon className='difficulty-slider-icon lvl-0' size={16} icon={getTaskDifficultyIcon(0)}></Icon>, color: '#1976d2' },
    { value: 1, label: <Icon className='difficulty-slider-icon lvl-1' size={16} icon={getTaskDifficultyIcon(1)}></Icon>, color: '#00796b' },
    { value: 2, label: <Icon className='difficulty-slider-icon lvl-2' size={16} icon={getTaskDifficultyIcon(2)}></Icon>, color: '#dbb02d' },
    { value: 3, label: <Icon className='difficulty-slider-icon lvl-3' size={16} icon={getTaskDifficultyIcon(3)}></Icon>, color: '#e64a19' },
    { value: 4, label: <Icon className='difficulty-slider-icon lvl-4' size={16} icon={getTaskDifficultyIcon(4)}></Icon>, color: '#d32f2f' }
];

// const difficulties = [
//     { value: 0, label: 'Lvl. 0', color: '#1976d2' },
//     { value: 1, label: 'Lvl. 1', color: '#00796b' },
//     { value: 2, label: 'Lvl. 2', color: '#dbb02d' },
//     { value: 3, label: 'Lvl. 3', color: '#e64a19' },
//     { value: 4, label: 'Lvl. 4', color: '#d32f2f' }
// ]

export default function TaskEditDifficulty({ className, difficulty, onChange }: Props) {
    const [rawDifficulty, setRawDifficulty] = useState<TaskDifficulty>(difficulty || 0)

    function change(value: any) {
        onChange(value as never);
        setRawDifficulty(value);
    }

    useEffect(() => {
        setRawDifficulty(difficulty || 0);
    }, [difficulty]);

    return (
        <Wrapper className={className}>
            <div className={`difficulty-art lvl-${rawDifficulty}`}>
                <div className='difficulty-subtitle'>Difficulty</div>
                <div className='difficulty-title'>{getTaskDifficultyDisplayName(rawDifficulty)}</div>
                {<Icon className='difficulty-icon' size={30} icon={getTaskDifficultyIcon(rawDifficulty)}></Icon>}
            </div>
            <div className={`difficulty-slider-container lvl-${rawDifficulty}`}>
                <Slider size={SliderSize.SMALL} min={-0.1} max={4.1} value={rawDifficulty} onChange={change} marks={difficulties} step='marks' customLabel={getTaskDifficultyDisplayName}></Slider>
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    padding: 10px 0;
    display: flex;
    flex-direction: column;

    .difficulty-slider-mark-label {
        padding: 5px;
        border-radius: 8px;
    }

    .difficulty-art {
        position: relative;
        transition: background-color var(--ui-animation-duration);
        min-height: 100px;
        width: 100%;
        border-radius: 10px 10px 0 0;
        flex-grow: 1;

        &.lvl-0 { background-color: #1976d244; }
        &.lvl-1 { background-color: #00796b44; }
        &.lvl-2 { background-color: #dbb02d44; }
        &.lvl-3 { background-color: #e64a1944; }
        &.lvl-4 { background-color: #d32f2f44; }
    }

    .difficulty-title {
        position: absolute;
        top: 32px;
        left: 20px;
        font-size: 16px;
        font-weight: 700;
    }

    .difficulty-subtitle {
        position: absolute;
        top: 18px;
        left: 20px;
        font-size: 11px;
        font-weight: 700;
        opacity: 0.5;
    }

    .difficulty-icon {
        position: absolute;
        bottom: 14px;
        right: 14px;
        padding-top: 10px;
    }

    .difficulty-slider-container {
        /* margin-top: -10px; */
        padding: 0px 30px 20px 30px;
        border-radius: 0 0 10px 10px;
        transition: background-color var(--ui-animation-duration);

        .slider-mark { margin-top: 5px; }
        .difficulty-slider-icon { filter: grayscale(1); transition: filter 0.22s; }

        &.lvl-0 .lvl-0 { filter: grayscale(0) }
        &.lvl-1 .lvl-1 { filter: grayscale(0) }
        &.lvl-2 .lvl-2 { filter: grayscale(0) }
        &.lvl-3 .lvl-3 { filter: grayscale(0) }
        &.lvl-4 .lvl-4 { filter: grayscale(0) }

        &.lvl-0 { background-color: #1976d222; }
        &.lvl-1 { background-color: #00796b22; }
        &.lvl-2 { background-color: #dbb02d22; }
        &.lvl-3 { background-color: #e64a1922; }
        &.lvl-4 { background-color: #d32f2f22; }
    }
`